<span (click)="toggleDepartments()" id="toggle">
  <span id="toggle-top" class="toggle-text">
    <span id="toggle-text-wrapper">{{toggleLabel}}
      <span *ngIf="selectedDepartments.length >= 2 && unselectedDepartments.length" id="additional" class="toggle-text">
        {{additionalLabel}}</span>
    </span>
    <i class="fa fa-caret-down"></i></span>
</span>
<div id="department-dropdown" *ngIf="showDepartments">
  <div id="list-wrapper">
    <div class="input-search-wrapper">
      <i id="search-glass" class="fa fa-search search-icon" aria-hidden="true"
       [matTooltip]="'3 letters required'" [matTooltipPosition]="'above'"
       [matTooltipDisabled]="searchText.length >= 3" [matTooltipClass]="'custom-tooltip'"></i>
      <input type="text" placeholder="Search..." id="search-for" (input)="onSearchTextChanged()" [(ngModel)]="searchText">
    </div>
    <mat-checkbox (click)="selectAllDepartments($event)" [checked]="displayedSelectedDepartments.length &&
     !displayedUnselectedDepartments.length" id="select-all">Select All</mat-checkbox>
    <div class="department-section-heading">Selected Departments</div>
    <div *ngFor="let department of displayedSelectedDepartments" class="department-item"
         (click)="whenDepartmentClicked(department, $event)">
      <mat-checkbox [checked]="true" class="selected-department">{{department.item.item.departmentNodeName}}</mat-checkbox>
    </div>
    <div class="department-section-heading">Other Departments</div>
    <div *ngFor="let department of displayedUnselectedDepartments" class="department-item"
         (click)="whenDepartmentClicked(department, $event)">
      <mat-checkbox [checked]="false" class="unselected-department">{{department.item.item.departmentNodeName}}</mat-checkbox>
    </div>
  </div>
  <div id="buttons-wrapper">
    <button (click)="apply()" id="btn-apply">Apply</button>
    <button (click)="cancel()" id="btn-cancel">Cancel</button>
  </div>
</div>
